// extracted by mini-css-extract-plugin
export default {"container":"PageLayout_container__TggXE","card":"PageLayout_card__H+MM6","content":"PageLayout_content__PJlNQ"};